import type { Questionnaire } from '@medplum/fhirtypes'
import type { Participant } from '@seen/core/models/patients/participant'
import { ExtendedQuestionnaireResponse } from '@seen/core/models/questionnaireResponse'
import type { JSX } from 'react'
import { QuestionnaireItemForm } from '#src/components/questionnaire-form/questionnaire-item-form/QuestionnaireItemForm.tsx'
import { useSearchOneOrCreate } from '#src/hooks/useSearchOneOrCreate.ts'

export function QuestionnaireForm({
  questionnaire,
  participant,
  excludeLinkIds,
}: {
  questionnaire: Questionnaire
  participant: Participant
  excludeLinkIds?: string[]
}): JSX.Element {
  const questionnaireResponseResult = useSearchOneOrCreate(
    ExtendedQuestionnaireResponse.searchQuery({
      questionnaire,
      subject: participant.reference,
    }),
    ExtendedQuestionnaireResponse.buildFromQuestionnaire({
      questionnaire,
      subject: participant.reference,
    })
  )
  const qr = questionnaireResponseResult.data ?? null

  return (
    <>
      {questionnaire.item
        ?.filter((item) => !excludeLinkIds?.includes(item.linkId))
        .map((item) => (
          <QuestionnaireItemForm
            key={item.linkId}
            item={item}
            label={item.text}
            questionnaireResponse={qr}
          />
        ))}
    </>
  )
}
